import { render } from "./UserHistoryItem.vue?vue&type=template&id=2f6dc316"
import script from "./UserHistoryItem.vue?vue&type=script&lang=js"
export * from "./UserHistoryItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__